import { Component, OnInit,Input } from '@angular/core';
import { ResultAlertError } from '@app/enums/errors.enum';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {PassengerService} from '@app/services/micro/passenger.service';
import {GlobalsService} from "@services/micro/globals.service";
import {Passenger} from '@app/models/micro/passenger.model';

/**
 * Componente para mostrar un modal de errores personalizable.
 * Este componente permite mostrar mensajes de error en un modal con opciones configurables,
 * como título, mensaje, código de error, iconos, botones, colores, entre otros.
 * Además, gestiona la selección de pasajeros y su relación con la reserva actual.
 */
@Component({
    selector: 'app-errors-modal-ckn',
    templateUrl: './errors-modal-ckn.component.html',
    styleUrls: ['./errors-modal-ckn.component.scss'],
    standalone: false
})
export class  ErrorsModalCknComponent implements OnInit {
/**
    Título del error.
  **/
    @Input() public titleError: string = '';

    /**
      Mensaje de error.
    **/
    @Input() public msgError: string = '';
  
    /**
      Código del error.
    **/
    @Input() public codeError: string = '';
  
    /**
      Identificador único del error.
    **/
    @Input() public uuidError: string = '';
  
    /**
      Indica si se debe imprimir una tarjeta.
    **/
    @Input() public printCard: string = '';
  
    /**
      Color de fondo del modal.
    **/
    @Input() public backgroundColorModal: string = 'am-blue-premium';
  
    /**
      Indica si se muestra el botón de acción.
    **/
    @Input() public showButton: boolean = true;
  
    /**
      Texto del botón de acción.
    **/
    @Input() public buttonCopy: string = '';
  
    /**
      Indica si se muestra un ícono o imagen.
    **/
    @Input() public showIconImage: boolean = true;
  
    /**
      URL del ícono o imagen.
    **/
    @Input() public urlIconImage: string = '';
  
    /**
      Color de la fuente del botón.
    **/
    @Input() public colorFontButton: string = '';
  
    /**
      Color de fondo del botón.
    **/
    @Input() public backGroundButton: string = '';
  
    /**
      Tamaño del modal.
    **/
    @Input() public sizeModal: string = '';
  
    /**
      Peso de la fuente del título del error.
    **/
    @Input() public fontWeightTitleError: string = '';
  
    /**
      Imagen adicional para mostrar en el modal.
    **/
    @Input() public image: string = '';
  
    /**
      Indica si se muestra el botón de cancelar.
    **/
    @Input() public showCancelButton = false;
  
    /**
      Texto del botón de cancelar.
    **/
    @Input() public cancelButtonText = '';
    
    /**
      Texto del botón de cancelar.
    **/
    @Input() public showListPassengers = true;
  
    /**
      Lista de pasajeros seleccionados.
    **/
    passengerSelected: Passenger[];
  
    /**
      Pasajero actual.
    **/
    currentPassenger: Passenger;
  
    /**
      Lista de todos los pasajeros.
    **/
    passengers: Array<Passenger> = [];
  
    /**
      Número de pasajeros en la reserva.
    **/
    noPassPnr: number;
  
    /**
      Número de pasajeros seleccionados.
    **/
    noPassSele: number;
  
    /**
      Indica si todos los pasajeros están seleccionados.
    **/
    isAllPass: boolean = false;

  constructor(
    private modalService: NgbActiveModal,
    private _passengerService: PassengerService,
    private global: GlobalsService
  ) { }

  ngOnInit(): void {
    this.passengerSelected = this._passengerService.getPassengerSelection();
    this.noPassPnr = this.global.reservation.passengers.length;
    this.noPassSele = this._passengerService.getPassengerSelection().length;

    if(this.noPassPnr == this.noPassSele){
      this.isAllPass = true;
    }
  }
  /**
    Cierra el modal con una operación de aceptación.
    Este método se ejecuta cuando el usuario hace clic en el botón de acción.
    @return void - No retorna ningún valor, pero cierra el modal con la operación `ResultAlertError.ACCEPT`.
  **/
  actionBtn() {
    this.modalService.close({operation: ResultAlertError.ACCEPT})
  }
  /**
    Descarta el modal sin realizar ninguna operación.
    Este método se ejecuta cuando el usuario hace clic en el botón de cancelar.
    @return void - No retorna ningún valor, pero descarta el modal sin realizar ninguna acción adicional.
  **/
  actionBtnCancel(){
    this.modalService.dismiss();
  }

}

